import { render, staticRenderFns } from "./AccountTransferComplete.vue?vue&type=template&id=50f0b94e&"
import script from "./AccountTransferComplete.vue?vue&type=script&lang=js&"
export * from "./AccountTransferComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports